import { Component, Input} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ParamData } from '../../models/param-data';
import { TreeViewDataBase } from '../../models/tree-view-data-base';

@Component({
    selector: 'display-param-treeview-data',
    styleUrls: ['./display-param-treeview-data.scss'],
    template: `
        <div class='border-bottom mb-1 p-1'>
            <div class='display-param-tree-name'>
                <p class='m-0'>{{treeViewData.getParamPresentation().title}}</p>
            </div>
            <div class='display-param-tree-data' [innerHtml]='getDataOutput(paramData)'>
            </div>
        </div>
`
})
export class DisplayParamTreeViewDataComponent {
    @Input() paramData: ParamData;
    @Input() treeViewData: TreeViewDataBase;

    constructor(
        private translate: TranslateService
    ){}

    public getDataOutput(paramData: ParamData): string {
        let paramPresentation = this.treeViewData.getParamPresentation();
        let data = paramPresentation.getParamData();
        let output = '<div class="param-pres-wrapper">';

        if (!paramData.data || paramData.data.length === 0)
            output += '<i>'+ this.translate.instant('urval.my-selections.options.none') +'</i>';
        else if (paramData.data.length == 1 && data.length == 1)
            output += '<span>'+ this.translate.instant('urval.my-selections.options.yes') +'</span>';
        else if (paramData.data.length == data.length)
            output += '<span>'+ this.translate.instant('urval.my-selections.options.all') +'</span>';
        else
            output += paramPresentation.getParamDataOutput(paramData);

        output += '</div>';
        return output;
    }

}
